/* night night — ATC + drawer + upsell + sticky (selling_plan aware) + swatches + set subscribe-swap (bundle-priced mask). */
(function () {
  'use strict';

  var COLOR_MAP = {
    berry: '#B04A5A', midnight: '#1B2440', ocean: '#3E6B8F', dusk: '#56618F',
    blush: '#E8B4C0', onyx: '#111114', robin: '#7FD1C9', moonstone: '#C7C9D1',
    pearl: '#F4F1EA', sapphire: '#274B9F', honey: '#E3B23C', merlot: '#6E1F33', amber: '#E08A3C'
  };

  var MASK_VARIANT_ID = 44183342547047;
  /* subscription-flow mask uses the $10 bundle-price SKUs so mask+subscription totals $29.99 minus the 15% strip discount */
  var MASK_COLOR_TO_VARIANT = {
    Midnight: 44199127548007, Onyx: 44199127679079, Robin: 44199127711847, Blush: 44199127744615,
    Moonstone: 44199127777383, Pearl: 44199127810151, Sapphire: 44199127842919, Honey: 44199127875687,
    Merlot: 44199127908455, Amber: 44199127941223
  };
  var STRIP30_TO_90 = { 44183343759463: 44183385145447, 44183343792231: 44183385178215, 44183343824999: 44183385210983 };
  var STRIP90_IDS = [44183385145447, 44183385178215, 44183385210983];
  var SET_IDS = [44183385604199, 44198931038311, 44198931071079];
  var MONTHLY_PLAN_ID = 11667538023;
  var SET_TO_REAL_STRIP = { 44183385604199: 44183343759463, 44198931038311: 44183343792231, 44198931071079: 44183343824999 };

  function getDrawer() { return document.querySelector('cart-drawer'); }

  function buildUpsell(footer, opts) {
    var strip = document.createElement('div');
    strip.className = 'nn-cart-upsell';
    strip.innerHTML =
      '<div class="nn-cart-upsell__info">' +
      '<p class="nn-cart-upsell__title">' + opts.title + '</p>' +
      '<p class="nn-cart-upsell__price">' + opts.price + '</p>' +
      '</div>' +
      '<button type="button" class="nn-cart-upsell__btn" data-nn-atc data-variant-id="' + opts.variantId + '">add</button>';
    var checkoutEl = footer.querySelector('.nn-checkout-btn');
    footer.insertBefore(strip, checkoutEl);
  }

  function decorateDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    if (!inner.querySelector('.nn-cart-banner')) {
      var banner = document.createElement('div');
      banner.className = 'nn-cart-banner';
      banner.innerHTML = 'free us shipping on every order <strong>\uD83C\uDF19</strong> 30-night guarantee, always';
      inner.insertBefore(banner, inner.firstChild);
    }
    var footer = inner.querySelector('.drawer__footer');
    if (!footer) return;
    var nativeBtn = footer.querySelector('#CartDrawer-Checkout, button[name="checkout"]');
    if (nativeBtn) {
      var anchor = document.createElement('a');
      anchor.href = '/checkout'; anchor.className = 'nn-checkout-btn'; anchor.textContent = 'checkout \u2014 night night';
      nativeBtn.replaceWith(anchor);
    } else if (!footer.querySelector('.nn-checkout-btn')) {
      var a2 = document.createElement('a');
      a2.href = '/checkout'; a2.className = 'nn-checkout-btn'; a2.textContent = 'checkout \u2014 night night';
      footer.appendChild(a2);
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var existing = footer.querySelector('.nn-cart-upsell');
      if (existing) existing.remove();
      if (cart.item_count === 0) return;
      var ids = cart.items.map(function (i) { return i.variant_id; });
      var strip30InCart = ids.filter(function (id) { return STRIP30_TO_90[id]; });
      var has90 = ids.some(function (id) { return STRIP90_IDS.indexOf(id) > -1; });
      var hasSet = ids.some(function (id) { return SET_IDS.indexOf(id) > -1; });
      var hasMask = ids.indexOf(MASK_VARIANT_ID) > -1;
      if (strip30InCart.length && !has90) {
        buildUpsell(footer, { title: 'upgrade to 90 nights \u2014 save $14.98', price: '$44.99 \u00b7 50\u00a2 a night', variantId: STRIP30_TO_90[strip30InCart[0]] });
      } else if (!hasMask && !hasSet) {
        buildUpsell(footer, { title: 'complete the ritual \u2014 silk mask', price: '$14.99', variantId: MASK_VARIANT_ID });
      }
    }).catch(function () {});
  }

  async function refreshDrawer() {
    try {
      const res = await fetch(window.shopUrl + '/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshInner = parsed.querySelector('.drawer__inner');
      const drawer = getDrawer();
      if (!drawer) return;
      const currentInner = drawer.querySelector('.drawer__inner');
      if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
      drawer.classList.remove('is-empty');
      const items = drawer.querySelector('cart-drawer-items');
      if (items) items.scrollTop = 0;
      decorateDrawer();
    } catch (e) { console.error('nn drawer refresh failed', e); }
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) { window.location.href = window.routes.cart_url; return; }
    if (typeof drawer.open === 'function') { drawer.open(); }
    else { drawer.classList.add('active', 'animate'); document.body.classList.add('overflow-hidden'); }
  }

  async function addToCart(items) {
    const res = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
    });
    if (!res.ok) throw new Error('ATC failed ' + res.status);
    return res.json();
  }

  function currentSellingPlan() {
    var el = document.querySelector('input[name="selling_plan"]:checked');
    if (!el) return null;
    var v = el.value;
    if (!v || v === '0' || v.toLowerCase() === 'null' || v.toLowerCase() === 'onetime') return null;
    return v;
  }

  function selectSwatch(btn) {
    var group = btn.dataset.group;
    var container = btn.parentElement;
    container.querySelectorAll('[data-nn-swatch][data-group="' + group + '"]').forEach(function (b) {
      var active = b === btn;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.style.background = active ? '#1B2440' : '#fff';
      b.style.color = active ? '#FAF6EF' : '#1B2440';
      b.style.borderColor = active ? '#1B2440' : '#B9A7D9';
    });
    if (group === 'strip' && btn.dataset.price) {
      var box = btn.closest('[data-nn-buybox]');
      var priceEl = box && box.querySelector('[data-nn-price]');
      if (priceEl) priceEl.textContent = btn.dataset.price;
      var stickyPrice = document.querySelector('[data-nn-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = btn.dataset.price;
    }
  }

  function boxSelected(box, group) {
    if (!box) return null;
    return box.querySelector('[data-nn-swatch][data-group="' + group + '"][aria-pressed="true"]') || null;
  }

  function resolveVariantId(btn) {
    if (btn.dataset.variantId) return btn.dataset.variantId;
    var box = btn.closest('[data-nn-buybox]');
    if (btn.hasAttribute('data-nn-sticky-atc')) {
      var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      if (formInput && formInput.value) return formInput.value;
      var sel = boxSelected(document.querySelector('[data-nn-buybox]'), 'strip');
      if (sel) return sel.dataset.variantId;
      return btn.dataset.fallbackVariantId || null;
    }
    var strip = boxSelected(box, 'strip');
    return strip ? strip.dataset.variantId : null;
  }

  document.addEventListener('click', async function (evt) {
    var swatch = evt.target.closest('[data-nn-swatch]');
    if (swatch) { evt.preventDefault(); selectSwatch(swatch); return; }

    const btn = evt.target.closest('[data-nn-atc]');
    if (!btn) return;
    evt.preventDefault();

    const box = btn.closest('[data-nn-buybox]');
    const subscribeBox = box && box.querySelector('[data-nn-subscribe-strips]');
    var items = [];

    if (subscribeBox && subscribeBox.checked) {
      var maskBtn = boxSelected(box, 'mask');
      var maskVariantId = maskBtn ? MASK_COLOR_TO_VARIANT[maskBtn.dataset.color] : MASK_COLOR_TO_VARIANT.Midnight;
      var stripBtn = boxSelected(box, 'strip');
      var realStripId = stripBtn && SET_TO_REAL_STRIP[parseInt(stripBtn.dataset.variantId, 10)];
      if (maskVariantId) items.push({ id: maskVariantId, quantity: 1 });
      if (realStripId) items.push({ id: realStripId, quantity: 1, selling_plan: MONTHLY_PLAN_ID });
    } else {
      const variantId = resolveVariantId(btn);
      if (!variantId) return;
      items = [{ id: parseInt(variantId, 10), quantity: parseInt(btn.dataset.quantity || '1', 10) }];

      if (btn.hasAttribute('data-nn-sticky-atc')) {
        var plan = currentSellingPlan();
        if (plan) items[0].selling_plan = parseInt(plan, 10);
      }

      if (box) {
        var maskBtn2 = boxSelected(box, 'mask');
        if (maskBtn2) items[0].properties = { 'mask color': maskBtn2.dataset.color };
      }
    }

    if (!items.length) return;

    const originalText = btn.textContent;
    btn.disabled = true; btn.textContent = 'adding\u2026';
    try {
      await addToCart(items);
      await refreshDrawer();
      openDrawer();
    } catch (e) {
      console.error(e);
      btn.textContent = 'try again';
      setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2000);
      return;
    }
    btn.disabled = false; btn.textContent = originalText;
  });

  function injectNativeDots() {
    try {
      document.querySelectorAll('label[for]').forEach(function (label) {
        if (label.querySelector('.nn-native-dot')) return;
        var input = document.getElementById(label.htmlFor);
        if (!input || input.type !== 'radio') return;
        var raw = (label.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var hex = COLOR_MAP[raw];
        if (!hex) {
          var words = raw.split(' ');
          for (var i = 0; i < words.length; i++) { if (COLOR_MAP[words[i]]) { hex = COLOR_MAP[words[i]]; break; } }
        }
        if (!hex) return;
        var dot = document.createElement('span');
        dot.className = 'nn-native-dot';
        dot.style.cssText = 'width:1.3rem !important;height:1.3rem !important;min-width:1.3rem !important;border-radius:50% !important;display:inline-block !important;visibility:visible !important;opacity:1 !important;margin-right:0.6rem !important;vertical-align:middle !important;border:1px solid rgba(0,0,0,0.25) !important;background:' + hex + ' !important;';
        label.insertBefore(dot, label.firstChild);
      });
    } catch (e) {}
  }

  function paintManualDots() {
    document.querySelectorAll('.nn-dot[data-nn-dot-for]').forEach(function (dot) {
      var name = (dot.getAttribute('data-nn-dot-for') || '').trim().toLowerCase();
      var hex = COLOR_MAP[name];
      if (hex) dot.style.background = hex;
    });
  }

  function mobileGalleryReorder() {
    try {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      var info = document.querySelector('.product__info-wrapper');
      var media = document.querySelector('.product__media-wrapper');
      if (!info || !media || info.contains(media)) return;
      var anchor = info.querySelector('.nn-pdp-rating') || info.querySelector('.product__title');
      if (anchor) { anchor.insertAdjacentElement('afterend', media); media.classList.add('nn-media-moved'); }
    } catch (e) {}
  }

  function initSticky() {
    var bar = document.querySelector('[data-nn-sticky]');
    if (!bar) return;
    var target = document.querySelector('form[action*="/cart/add"]') || document.querySelector('[data-nn-buybox]');
    if (!target || !('IntersectionObserver' in window)) { bar.hidden = false; return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.hidden = entry.isIntersecting; });
    }, { rootMargin: '-60px 0px 0px 0px' });
    io.observe(target);
  }

  function boot() {
    mobileGalleryReorder();
    paintManualDots();
    injectNativeDots();
    setTimeout(injectNativeDots, 300);
    setTimeout(injectNativeDots, 900);
    setTimeout(injectNativeDots, 2000);
    window.addEventListener('load', injectNativeDots);
    decorateDrawer();
    initSticky();
    var drawer = getDrawer();
    if (drawer && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (!drawer.querySelector('.nn-cart-banner') || !drawer.querySelector('.nn-checkout-btn')) decorateDrawer();
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }
    if (window.MutationObserver) {
      var mo2 = new MutationObserver(function () { injectNativeDots(); });
      mo2.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
